import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../utils/api';
import { useSuperadminAuth } from '../context/SuperadminAuthContext';

const SuperadminLoginPage = () => {
  const { login } = useSuperadminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API}/superadmin/auth/login`, { email, password });
      login(res.data.access_token, res.data.user);
      navigate('/superadmin', { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)',
      padding: 24,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div
        data-testid="superadmin-login-card"
        style={{
          width: '100%',
          maxWidth: 420,
          background: 'rgba(255, 255, 255, 0.06)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          borderRadius: 18,
          padding: 36,
          color: '#F8FAFC',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        }}
      >
        <div style={{ marginBottom: 28 }}>
          <div style={{
            display: 'inline-block', padding: '6px 14px', borderRadius: 999,
            background: 'rgba(220, 38, 38, 0.18)', border: '1px solid rgba(220, 38, 38, 0.4)',
            color: '#FCA5A5', fontSize: 11, fontWeight: 700, letterSpacing: 1, marginBottom: 14,
          }}>RESTRICTED · SUPERADMIN</div>
          <h1 style={{ fontSize: 28, fontWeight: 700, margin: '0 0 8px', letterSpacing: -0.5 }}>
            Platform Console
          </h1>
          <p style={{ fontSize: 14, color: '#94A3B8', margin: 0, lineHeight: 1.6 }}>
            Master access for managing every organisation and user on socialstar.
          </p>
        </div>

        {error && (
          <div data-testid="superadmin-login-error"
            style={{
              background: 'rgba(220, 38, 38, 0.15)',
              border: '1px solid rgba(220, 38, 38, 0.4)',
              color: '#FCA5A5', padding: '10px 14px', borderRadius: 10,
              fontSize: 13, marginBottom: 16,
            }}>{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#CBD5E1', marginBottom: 6 }}>
            Email
          </label>
          <input
            data-testid="superadmin-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="superadmin@socialstar.co"
            style={{
              width: '100%', padding: '12px 14px', marginBottom: 16,
              borderRadius: 10, border: '1px solid rgba(255,255,255,0.12)',
              background: 'rgba(15, 23, 42, 0.6)', color: '#F8FAFC',
              fontSize: 14, outline: 'none', boxSizing: 'border-box',
            }}
          />
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#CBD5E1', marginBottom: 6 }}>
            Password
          </label>
          <input
            data-testid="superadmin-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="••••••••"
            style={{
              width: '100%', padding: '12px 14px', marginBottom: 24,
              borderRadius: 10, border: '1px solid rgba(255,255,255,0.12)',
              background: 'rgba(15, 23, 42, 0.6)', color: '#F8FAFC',
              fontSize: 14, outline: 'none', boxSizing: 'border-box',
            }}
          />
          <button
            data-testid="superadmin-login-submit"
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '13px', borderRadius: 10,
              background: loading ? '#475569' : 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',
              color: '#fff', fontSize: 14, fontWeight: 600,
              border: 'none', cursor: loading ? 'not-allowed' : 'pointer',
              letterSpacing: 0.3,
            }}
          >
            {loading ? 'Signing in…' : 'Access Console'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SuperadminLoginPage;
